// Référentiel des champs qu'une demande de compléments peut redemander au client :
// groupes de la palette, pièces jointes, jumelages imposés par l'API et valeur actuelle
// de chaque champ sur la déclaration.

export const FIELD_GROUPS = [
  {
    key: "documents",
    fields: [
      "id_card",
      "product_invoice",
      "invoice_holder_proof",
      "complaints_receipt",
      "anti_theft_device_invoice",
      "product_photos",
      "marking_number_photos",
      "fraudulent_sim_use_proof",
      "home_insurance_certificate",
    ],
  },
  {
    key: "circumstances",
    fields: [
      "occurrence_date",
      "occurred_at_home",
      "occurrence_place",
      "theft_type",
      "breakdown_repaired_by_manufacturer",
      "breakdown_impact_or_drop",
      "description",
      "is_invoice_holder",
      "marking_number",
      "fraudulent_sim_use",
      "no_other_compensation_attested",
    ],
  },
  {
    key: "personal_information",
    fields: [
      "first_name",
      "last_name",
      "phone",
      "birth_date",
      "street_number",
      "street",
      "zip_code",
      "city",
      "country",
    ],
  },
];

export const FILE_FIELDS = new Set(FIELD_GROUPS[0].fields);

export const DATE_FIELDS = new Set(["occurrence_date", "birth_date"]);

// Combinaisons imposées par Claims::DeclarationUpdateRequest#fields_combinations : en demander
// un seul des deux fait échouer l'enregistrement (422).
export const PAIRED_FIELDS = {
  occurrence_place: "occurred_at_home",
  occurred_at_home: "occurrence_place",
  home_insurance_certificate: "no_other_compensation_attested",
  no_other_compensation_attested: "home_insurance_certificate",
  invoice_holder_proof: "is_invoice_holder",
  is_invoice_holder: "invoice_holder_proof",
};

const toCamelCase = (field) => field.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

// Valeur actuelle du champ sur la déclaration (liste de fichiers pour une pièce jointe).
export function currentValue(declaration, field) {
  const value = declaration?.[toCamelCase(field)];
  if (FILE_FIELDS.has(field)) return Array.isArray(value) ? value : value ? [value] : [];
  return value ?? null;
}

// Un champ est proposé quand il a une réponse à corriger. Une pièce jointe l'est toujours :
// la redemander est justement utile quand elle manque. Le lieu du sinistre suit la question
// « à domicile », et le justificatif titulaire la question titulaire, auxquels ils sont jumelés.
export function isRequestable(declaration, field) {
  if (field === "invoice_holder_proof") return declaration?.isInvoiceHolder != null;
  if (FILE_FIELDS.has(field) || field === "occurrence_place") return true;
  return currentValue(declaration, field) !== null;
}

// Champs envoyés à l'API : ceux demandés, complétés de leur jumeau obligatoire.
export function withPairedFields(fields) {
  const paired = fields.map((field) => PAIRED_FIELDS[field]).filter(Boolean);
  return [...new Set([...fields, ...paired])];
}
